const baseURL = "/v1/PeriodoFormacao";

const service = {
  methods: {
    $buscarPeriodos(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $visualizarPeriodoFormacao({ params, id }) {
      return this.$api().get(`${baseURL}/${id}`, params);
    },
    $cadastrarPeriodoFormacao(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarPeriodoFormacao(body, id) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $inativarAtivarPeriodoFormacao(body, id) {
      return this.$api().patch(`${baseURL}/${id}/AlterarStatus`, body);
    },
    $excluirPeriodoFormacao(body, id) {
      return this.$api().delete(`${baseURL}/${id}`, body);
    },
    $detalharUsoPeriodoFormacao({ id, params}) {
      return this.$api().get(`${baseURL}/DetalharUso/${id}`, params);
    },
  },
};

export default service;
